/*
 * @Author: DaLong Li
 * @Date: 2025-02-19 19:30:47
 * @LastEditTime: 2025-02-19 19:50:02
 * @LastEditors: DaLong Li
 * @Description: 
 * 生命在于运动，代码在于抽动。
 */
import { createRouter, createWebHistory } from 'vue-router'
import MainLayout from '@/components/layout/MainLayout.vue'

const routes = [
    {
        path: '/',
        component: MainLayout,
        children: [
            {
                path: '',
                name: 'Home',
                component: () => import('@/views/home/index.vue')
            },
            {
                path: 'products',
                name: 'Products',
                component: () => import('@/views/products/index.vue')
            },
            {
                path: 'resources',
                name: 'Resources',
                component: () => import('@/views/resources/index.vue')
            },
            {
                path: 'about',
                name: 'About',
                component: () => import('@/views/about/index.vue')
            },
            {
                path: 'news',
                name: 'News',
                component: () => import('@/views/news/index.vue')
            },
            {
                path: 'newsDetail',
                name: 'NewsDetail',
                component: () => import('@/views/news/newDetail.vue')
            },
            {
                path: 'contact',
                name: 'Contact',
                component: () => import('@/views/contact/index.vue')
            }
        ]
    }
]

const router = createRouter({
    history: createWebHistory(),
    routes,
    scrollBehavior() {
        return { top: 0 }
    }
})

export default router
